import React, {
  useEffect,
} from 'react';
import Table from 'core/components/VirtualTable';
import {
  FaxViewDTO,
} from 'dtos';
import columns from 'pages/Dashboard/pages/Fax/Overview/columns';
import {
  useSidePanel,
  useMedia,
} from 'core/hooks';
import {
  getFaxesData,
} from 'pages/Dashboard/pages/Fax/transport';
import {
  faxEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  ListQueryProps,
} from 'pages/Dashboard/pages/Fax/types';

export default function QueryTable({
  dateRange,
  filterQuery,
  searchQuery,
  tableInstanceRef,
}: ListQueryProps) {
  const { openPanel } = useSidePanel();
  const { requestMedia } = useMedia();

  useEffect(() => {
    const unsubscribeFromChangeFax = faxEventChannel.on('onFaxChange', () => {
      tableInstanceRef?.current?.refetch?.();
    });
    const unsubscribeFromUpdateFaxDetails = faxEventChannel.on('onUpdateFaxDetails', async (id: number) => {
      const refetchedFaxes = await tableInstanceRef?.current?.refetch?.();
      const entity = refetchedFaxes?.data?.find((fax: FaxViewDTO) => fax.id === id);
      openPanel('fax', {
        ...entity,
        refetchFaxes: tableInstanceRef?.current?.refetch,
        id,
      });
    });

    return () => {
      unsubscribeFromChangeFax();
      unsubscribeFromUpdateFaxDetails();
    };
  }, []);

  return (
    <Table<FaxViewDTO>
      instanceRef={tableInstanceRef}
      onRowClick={(_table, row) => {
        openPanel('fax', {
          ...row.original,
          id: row.original.id ?? 0,
          refetchFaxes: tableInstanceRef?.current?.refetch,
        });
      }}
      getData={getFaxesData}
      queryParams={{
        dateRange,
        filterQuery,
        requestMedia,
        searchQuery,
      }}
      getRowId={(row) => row.id}
      columns={columns}
      emptySlot="No Faxes Found"
      classes={{
        header: 'px-4',
        scrollContainer: 'justify-center items-center',
        outerRow: '!w-[calc(100%-16px)] left-4',
        row: 'py-1',
      }}
      defaultPagination={{
        pageSize: 25,
        pageIndex: 0,
      }}
    />
  );
}
